import { RawLocation } from 'vue-router';
import { store } from '@/store';
import { questionnaireService } from '@/services/questionnaire/api';
import routeService from '@/services/RouteService';
import { RolesEnum } from '@/types/enum/RolesEnum';
import { router } from '@/router';
import { Next } from './types';

export async function redirectToUserPage(next?: Next): Promise<void> {
	const userType = store.getters['auth/getUserType'];

	const destination = await determineUserDestination(userType);

	if (next) {
		next(destination);
	} else {
		await router.replace(destination);
	}
}

async function determineUserDestination(userType: string | null): Promise<RawLocation> {
	const isCguValid = store.getters['auth/isCguValid'];

	if (!isCguValid) {
		return { name: 'updateCgu' };
	}

	const savedRedirect = getSavedRedirect();
	if (savedRedirect) {
		return savedRedirect;
	}

	switch (userType) {
		case RolesEnum.ASSURE:
			return { name: 'dossierAssure' };

		case RolesEnum.EMPLOYEUR:
			return { name: 'dossierEmployeur' };

		case RolesEnum.TEMOIN:
			return await getTemoinDestination();

		default:
			return { name: 'home' };
	}
}

function getSavedRedirect(): RawLocation | null {
	if (!routeService.hasRedirectTo()) {
		return null;
	}

	const goTo = routeService.getRedirectTo();
	if (goTo?.name) {
		routeService.deleteRedirectTo();
		return {
			name: goTo.name,
			params: goTo.params
		};
	}

	return null;
}

async function getTemoinDestination(): Promise<RawLocation> {
	const response = await questionnaireService.getIdQuestionnaireTemoin();

	if (response.data.idV4) {
		await store.dispatch('auth/logout');
	}

	if (response.data.id) {
		return {
			name: 'questionnaire',
			params: { reponseId: response.data.id }
		};
	}

	return { name: 'home' };
}
